// <auto-generated/>
// Contents of: hl7.fhir.r4.core version: 4.0.1
  // Primitive Naming Style: None
  // Complex Type / Resource Naming Style: PascalCase
  // Interaction Naming Style: None
  // Extension Support: NonPrimitive
  // Restricted to: Patient|Encounter|Questionnaire|QuestionnaireResponse|Observation|GuidanceResponse|CarePlan|ServiceRequest|Parameters|OperationOutcome
  // Language option: "namespaceRoot" = "IntgelligentNav.Fhir"
  // Language option: "partialClasses" = "true"
  // Language option: "systemTextJson" = "true"
  // Language option: "tolerantEnums" = "true"
  // Language option: "singleFile" = "false"
// Minimum TypeScript Version: 3.7
import * as fhir from '../fhir'
/**
 * A set of ordered Quantities defined by a low and high limit.
 */
export type IRange = fhir.IFhirElement & {
  /**
   * If the high element is missing, the high boundary is not known.
   */
  high?: fhir.IQuantity|undefined;
  /**
   * If the low element is missing, the low boundary is not known.
   */
  low?: fhir.IQuantity|undefined;
}
/**
 * A set of ordered Quantities defined by a low and high limit.
 */
export class Range extends fhir.FhirElement implements fhir.IRange {
  /**
   * If the high element is missing, the high boundary is not known.
   */
  public high?: fhir.Quantity|undefined;
  /**
   * If the low element is missing, the low boundary is not known.
   */
  public low?: fhir.Quantity|undefined;
  /**
   * Default constructor for Range - initializes any required elements to null if a value is not provided.
   */
  constructor(source:Partial<fhir.IRange> = {}) {
    super(source);
    if (source["high"]) { this.high = new fhir.Quantity(source.high!); }
    if (source["low"]) { this.low = new fhir.Quantity(source.low!); }
  }
  /**
   * Check if the current Range contains all required elements.
   */
  override checkRequiredElements():string[] {
    var missingElements:string[] = [];
    var parentMissing:string[] = super.checkRequiredElements();
    missingElements.push(...parentMissing);
    return missingElements;
  }
  /**
   * Factory function to create a Range from an object that MUST contain all required elements.
   */
  static override fromStrict(source:fhir.IRange):Range {
    var dest:Range = new Range(source);
    var missingElements:string[] = dest.checkRequiredElements();
    if (missingElements.length !== 0) { throw `Range is missing elements: ${missingElements.join(", ")}` }
    return dest;
  }
}
